<template>
    <app-layout>
      <template #header>
        <h1>Mostrar Dias</h1>
      </template>
      <div class="flex items-center justify-center w-full">
        <Link
          :href="route('dias.create')"
          class="mt-9 font-semibold leading-none text-white py-4 px-10 bg-blue-700 rounded hover:bg-blue-600 focus:ring-2 focus:ring-offset-2 focus:ring-blue-700 focus:outline-none">
          Nuevo Dia
        </Link>     
      </div>
      <table class="table-auto w-full">
        <thead class="text-xs font-semibold uppercase text-gray-400 bg-gray-50">
                            <tr>
                                <th class="p-2 whitespace-nowrap">
                                    <div class="font-semibold text-left">ID</div>
                                </th>
                                <th class="p-2 whitespace-nowrap">
                                    <div class="font-semibold text-left">NOMBRE</div>
                                </th>
                                <th class="p-2 whitespace-nowrap">
                                    <div class="font-semibold text-center">OPCIONES</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody class="text-sm divide-y divide-gray-100">
                            <tr v-for="dia in dias" :key="dia.id">
                                <td class="p-2 whitespace-nowrap">
                                    <div class="font-medium text-gray-800">{{dia.id}}</div>
                                </td>
                                <td class="p-2 whitespace-nowrap">
                                    <div class="text-left font-medium text-green-500">{{dia.nombre}}</div>
                                </td>
                                <td class="p-2 whitespace-nowrap">
                                    <Link
                                      :href="route('dias.edit', dia.id)"
                                      class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 border border-blue-500 rounded">
                                      Editar
                                    </Link>
                                    <button @click="destroy(dia.id)" class="bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-2 border border-red-500 rounded">Borrar</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
    </app-layout>
</template>
<script>
import AppLayout from "@/Layouts/AppLayout"
import { defineComponent } from 'vue'
import { Head, Link } from '@inertiajs/inertia-vue3';
export default defineComponent ({
  props:{
    dias: Array
  },
  components: { 
    AppLayout,
    Head,
    Link,
  },
  methods: {
    destroy: function(id){
      this.$inertia.delete('/dias/' + id);
      Toast.fire({
        icon: 'warning',
        title: 'Dia Borrado'
      })
    }        
  }
});
</script>